/** Youvia whitelabel theme entry. */

import type { WhitelabelThemeEntry } from '../../types';
import { youviaDefaultTheme } from './default';

export { youviaWhitelabel } from './default';

export const youviaWhitelabelThemeEntry: WhitelabelThemeEntry = {
  themes: {
    default: youviaDefaultTheme,
  },
};
